import { render, staticRenderFns } from "./website.vue?vue&type=template&id=08cb33c0"
import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./website.vue?vue&type=style&index=0&id=08cb33c0&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "37013dcd"
  
)

export default component.exports